import { makeGetRequestSettings } from '../../../services/common/utils';

import { ILiveCameras } from '../types';
import apiClient from '../../../services/common/apiClient';
import { makeMonitoredObjectsUrl } from '../../../services/monitored';

export interface ILiveViewCommandParams {
    state: 'start' | 'stop';
}

export const restGetActiveLiveViews = (id: string): Promise<ILiveCameras> =>
    apiClient.send(
        makeGetRequestSettings(makeMonitoredObjectsUrl(`/movies/live/${id}`))
    );
